import React from 'react'
import MaterialBox from '../../../../components/MaterialBox'
import MaterialTypography from '../../../../components/MaterialTypography'
import { Avatar } from '@mui/material'

const TeamsCard = ({ teamMembers = [] }) => {
    const defaultTeamMembers = [
        {
            id: 1,
            name: 'Jay Hargudson',
            role: 'Project Manager',
            avatar: null,
            phone: '+1234567890',
            email: 'jay@example.com'
        },
        {
            id: 2,
            name: 'Linda Blair',
            role: 'Mobile Developer',
            avatar: null,
            phone: '+1234567891',
            email: 'linda@example.com'
        },
        {
            id: 3,
            name: 'Jessica Patricia',
            role: 'Front End Developer',
            avatar: null,
            phone: '+1234567892',
            email: 'jessica@example.com'
        },
        {
            id: 4,
            name: 'John Bushmill',
            role: 'UI/UX Designer',
            avatar: null,
            phone: '+1234567893',
            email: 'john@example.com'
        },
        {
            id: 5,
            name: 'Dainel Sam',
            role: 'Testing Lead',
            avatar: null,
            phone: '+1234567894',
            email: 'dained@gmail.com'
        },
        {
            id: 6,
            name: 'Dainel Sam',
            role: 'Technical Manager',
            avatar: null,
            phone: '+1234567894',
            email: 'dained@gmail.com'
        },
        {
            id: 7,
            name: 'Dainel Sam',
            role: 'Technical Manager',
            avatar: null,
            phone: '+1234567894',
            email: 'dained@gmail.com'
        },
        {
            id: 8,
            name: 'Dainel Sam',
            role: 'Technical Manager',
            avatar: null,
            phone: '+1234567894',
            email: 'dained@gmail.com'
        }
    ];

    const members = teamMembers.length > 0 ? teamMembers : defaultTeamMembers;

    return (
        <MaterialBox
            sx={{
                border: '1px solid #ccd2d9',
                borderRadius: 3,
                padding: 1,
                height: "310px",
                display: 'flex',
                flexDirection: 'column'
            }}>
            <MaterialBox sx={{ display: 'flex', flexDirection: 'row', gap: 0.5, alignItems: 'center', mb: 2 }}>
                <MaterialBox sx={{ width: '6px', height: '12px', borderRadius: '30%', backgroundColor: '#5682e8' }} />
                <MaterialTypography variant='body2' fontWeight='bold' color='dark'>Teams</MaterialTypography>
            </MaterialBox>

            <MaterialBox
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    flex: 1,
                    overflowY: 'auto',
                    '&::-webkit-scrollbar': {
                        display: 'none'
                    },
                    msOverflowStyle: 'none',
                    scrollbarWidth: 'none'
                }}
            >
                {members.map((member) => (
                    <MaterialBox
                        key={member.id}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <MaterialBox sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Avatar
                                src={member.avatar}
                                alt={member.name}
                                sx={{
                                    width: 30,
                                    height: 30,
                                    bgcolor: '#5682e8'
                                }}
                            >
                                {member.name.charAt(0)}
                            </Avatar>
                            <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                                <MaterialTypography
                                    variant='caption'
                                    fontWeight='bold'
                                    color='dark'
                                    sx={{ lineHeight: 1.3 }}
                                >
                                    {member.name}
                                </MaterialTypography>
                                <MaterialTypography
                                    variant='caption'
                                    color='text'
                                    sx={{ fontSize: '0.75rem', color: '#6c757d' }}
                                >
                                    {member.role}
                                </MaterialTypography>
                            </MaterialBox>
                        </MaterialBox>
                    </MaterialBox>
                ))}
            </MaterialBox>
        </MaterialBox>
    )
}

export default TeamsCard